"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useAsync_1 = require("./useAsync");
var useAsyncRetry = function (fn, args) {
    if (args === void 0) { args = []; }
    var _a = react_1.useState(0), attempt = _a[0], setAttempt = _a[1];
    var memoized = react_1.useCallback(function () { return fn(); }, args.concat([attempt]));
    var state = useAsync_1.default(memoized);
    var retry = react_1.useCallback(function () {
        if (state.loading) {
            if (process.env.NODE_ENV === 'development') {
                console.log('You are calling useAsyncRetry hook retry() method while loading in progress, this is a no-op.');
            }
            return;
        }
        setAttempt(attempt + 1);
    }, [memoized, state, attempt]);
    return __assign({}, state, { retry: retry });
};
exports.default = useAsyncRetry;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/lib/useAsyncRetry.js
// module id = 1185
// module chunks = 17